import { render, staticRenderFns } from "./QuestionTutor.vue?vue&type=template&id=08a8b8c0&scoped=true"
import script from "./QuestionTutor.vue?vue&type=script&lang=ts"
export * from "./QuestionTutor.vue?vue&type=script&lang=ts"
import style0 from "./QuestionTutor.vue?vue&type=style&index=0&id=08a8b8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8b8c0",
  null
  
)

export default component.exports